import React from 'react';
import { ReactComponent as DocOutIcon } from '../../../resource/DocOutIcon.svg';
import { ReactComponent as DocInIcon } from '../../../resource/DocInIcon.svg';
import { ReactComponent as DocORDIcon } from '../../../resource/DocORDIcon.svg';
import { ReactComponent as DocAgreementIcon } from '../../../resource/DocAgreementIcon.svg';
import { ReactComponent as DocOssIcon } from '../../../resource/DocOssIcon.svg';
import { ReactComponent as UserCircleIcon } from '../../../resource/UserCircleIcon.svg';
import { Icon } from 'antd';

export const docTypes = {
  outgoing: 1, // Исходящий
  incoming: 2, // Входящий
  organizational: 3, // ОРД
  contract: 4, // Договор
  warranty: 5, // Претензия по гарантии !deprecated
  meeting: 6, // ОСС (общее собрание собственников)
  citizenAppeal: 7, //Обращение от гражданина
};

export const sourceTypes = {
  mail: 9, // Электронная почта
  web: 5, // Веб-приложение
};

export const sourceIcon = (type, size) => {
  switch (type) {
    case sourceTypes.mail: {
      return (
        <Icon
          type="mail"
          style={{ fontSize: size, verticalAlign: 'middle', color: '#0995ed' }}
        />
      );
    }
    case sourceTypes.web: {
      return (
        <Icon
          type="desktop"
          style={{ fontSize: size, verticalAlign: 'middle', color: '#0995ed' }}
        />
      );
    }
    default:
      return <div></div>;
  }
};

export const allowedNextTypes = {
  [docTypes.incoming]: [docTypes.citizenAppeal, docTypes.outgoing], // Входящий → ОРД, Исходящий
  [docTypes.citizenAppeal]: [docTypes.outgoing, docTypes.incoming], // Обращение от гражданина → Исходящий, Входящий
  [docTypes.outgoing]: [docTypes.citizenAppeal, docTypes.incoming], // Исходящий → ОРД, Входящий
};

export const documentsConstants = {
  docTypeIcon: (type, size) => {
    switch (type) {
      case docTypes.outgoing: {
        return <DocOutIcon style={{ height: size, verticalAlign: 'middle' }} />;
      }
      case docTypes.incoming: {
        return <DocInIcon style={{ height: size, verticalAlign: 'middle' }} />;
      }
      case docTypes.organizational: {
        return <DocORDIcon style={{ height: size, verticalAlign: 'middle' }} />;
      }
      case docTypes.contract: {
        return (
          <DocAgreementIcon style={{ height: size, verticalAlign: 'middle' }} />
        );
      }
      case docTypes.meeting: {
        return <DocOssIcon style={{ height: size, verticalAlign: 'middle' }} />;
      }
      default:
        return <div></div>;
    }
  },

  docTypeSVGIcon: (type, size) => {
    switch (type) {
      case docTypes.outgoing: {
        return (
          <DocOutIcon
            style={{ height: size, width: size, verticalAlign: 'middle' }}
          />
        );
      }
      case docTypes.incoming: {
        return (
          <DocInIcon
            style={{ height: size, width: size, verticalAlign: 'middle' }}
          />
        );
      }
      case docTypes.organizational: {
        return (
          <DocORDIcon
            style={{ height: size, width: size, verticalAlign: 'middle' }}
          />
        );
      }
      case docTypes.contract: {
        return (
          <DocAgreementIcon
            style={{ height: size, width: size, verticalAlign: 'middle' }}
          />
        );
      }
      case docTypes.meeting: {
        return (
          <DocOssIcon
            style={{ height: size, width: size, verticalAlign: 'middle' }}
          />
        );
      }
      case docTypes.citizenAppeal: {
        return (
          <UserCircleIcon
            style={{ height: size, width: size, verticalAlign: 'middle' }}
          />
        );
      }
      default:
        return null;
    }
  },

  SET_DATE_RANGE: 'DOCUMENTS_SET_DATE_RANGE',
  SELECT_DATE_RANGE: 'DOCUMENTS_SELECT_DATE_RANGE',
  CLOSE_FILTER: 'DOCUMENTS_CLOSE_FILTER',
  SET_FILTER_NEW_VISIBLE: 'SET_FILTER_NEW_VISIBLE',
  SET_DATE_RANGE_FIELD: 'DOCUMENTS_SET_DATE_RANGE_FIELD',
  SET_DOCUMENT_FILTER_VALUES: 'SET_DOCUMENT_FILTER_VALUES',
  FETCH_DOCUMENTS: 'FETCH_DOCUMENTS',
  SET_FILTER_STATUS: 'DOCUMENTS_SET_FILTER_STATUS',
  SET_FILTER_TYPE: 'DOCUMENTS_SET_FILTER_TYPE',
  RESET_FILTER: 'RESET_DOCUMENT_FILTER',
  APPLY_TYPE: 'APPLY_DOCUMENT_TYPE',
  APPLY_SUBTYPE: 'APPLY_DOCUMENT_SUBTYPE',
  APPLY_SERVICE_COMPANY: 'APPLY_SERVICE_COMPANY',
  APPLY_EXECUTER: 'APPLY_DOCUMENT_EXECUTER',
  APPLY_CREATOR: 'APPLY_DOCUMENT_CREATOR',
  SET_DOCUMENT_SEARCH: 'SET_DOCUMENT_SEARCH',
  APPLY_COMPANY: 'APPLY_DOCUMENT_COMPANY',
  UNSET_RESORT: 'UNSET_DOCUMENT_RESORT',
  APPLY_ADDR_STREET: 'APPLY_DOC_ADDR_STREET_FILTER',
  APPLY_ADDR_BUILDING: 'APPLY_DOC_ADDR_BUILDING',
  FETCH_ADDR_BUILDING: 'FETCH_DOC_ADDR_BUILDING',
  FETCH_ADDR_FLAT: 'FETCH_DOC_ADDR_FLAT',
  SET_ADDR_BUILDING_VALUE: 'SET_DOC_ADDR_BUILDING_FILTER_VALUE',
  SET_ADDR_FLAT_VALUE: 'SET_DOC_ADDR_FLAT_FILTER_VALUE',
  SET_VISIBLE_RELATED_DOCS_MODAL: 'SET_VISIBLE_RELATED_DOCS_MODAL',

  CLOSE_REPORT: 'CLOSE_REPORT',
  FETCH_SUBSERVICE: 'FETCH_SUBSERVICE',
  APPLY_WORKER: 'APPLY_WORKER',
  APPLY_STATUS: 'APPLY_STATUS',
  APPLY_SERVICE: 'APPLY_SERVICE_FILTER',
  APPLY_WARRANTY: 'APPLY_WARRANTY',
  APPLY_NOT_WARRANTY: 'APPLY_NOT_WARRANTY',
  APPLY_POSS_WARRANTY: 'APPLY_POSS_WARRANTY',
  APPLY_RETRY: 'APPLY_RETRY',
  APPLY_CHARGEABLE: 'APPLY_CHARGEABLE',
  APPLY_IMMEDIATE: 'APPLY_IMMEDIATE',
  APPLY_RESPONSIBLE_WORKER: 'APPLY_RESPONSIBLE',
  APPLY_BADWORK: 'APPLY_BADWORK',
  APPLY_DISTRICT: 'APPLY_DISTRICT',
  SET_REPORTS: 'SET_REPORTS',
  SET_REPORT: 'SET_REPORT',
  SET_FILTER_COMPANY: 'REQUESTS_SET_FILTER_COMPANY',
  SET_FILTER_WORKER: 'REQUESTS_SET_FILTER_WORKER',
  SET_FILTER_EXECUTER: 'SET_FILTER_EXECUTER',
  SET_FILTER_DISTRICT: 'SET_FILTER_DISTRICT',
  SET_SUBSERVICE_VALUE: 'SET_SUBSERVICE_FILTER_VALUE',
  SET_PHONE_VALUE: 'SET_PHONE_FILTER_VALUE',
  SET_RATING_VALUE: 'SET_RATING_FILTER_VALUE',
  SEARCH_REQUEST_BY_NUMBER: 'SEARCH_REQUEST_BY_NUMBER',
  POST_ERROR: 'POST_ERROR',
  SET_REQUEST_RATING: 'SET_REQUEST_RATING',
  SET_REQUEST_STATUS: 'SET_REQUEST_STATUS',
  SET_REQUEST_EXECUTE_TIME: 'SET_REQUEST_EXECUTE_TIME',
  SET_REQUEST_EXECUTER: 'SET_REQUEST_EXECUTER',
  SET_REQUEST_MASTER: 'SET_REQUEST_MASTER',
  SET_REQUEST_SERVICE: 'SET_REQUEST_SERVICE',
  MARK_REQUEST_VIEWED: 'MARK_REQUEST_VIEWED',
  SET_VIEW_OTHER_DOCS: 'SET_VIEW_OTHER_DOCS',
  SET_EXPIRED_MODE: 'SET_EXPIRED_MODE',
  SET_EXPIRED_MODE_QUERY: 'SET_EXPIRED_MODE_QUERY',
};
